import { render, staticRenderFns } from "./MisPerfiles.vue?vue&type=template&id=4696a091&scoped=true"
import script from "./MisPerfiles.vue?vue&type=script&lang=js"
export * from "./MisPerfiles.vue?vue&type=script&lang=js"
import style0 from "./MisPerfiles.vue?vue&type=style&index=0&id=4696a091&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4696a091",
  null
  
)

export default component.exports